export default __webpack_public_path__ + "static/media/upcomming.050a4fcd.png";